import { Component, OnInit } from '@angular/core';

import { InventoryService } from '../../services/inventory.service';
import { DetailsService } from '../../services/details.service';
import { NgxPicaService } from 'ngx-pica';
import { IInventoryType, IInventoryMasterDetail} from '../../interfaces/';
import { InventoryMasterDetail, ViewMasterDetailWithImage } from '../../models/';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'edit-inventory',
  templateUrl: './edit-inventory.component.html',
  styleUrls: ['./edit-inventory.component.css']
})
export class EditInventoryComponent implements OnInit {

  public genders: any[] = [];
  inventoryTypes: IInventoryType[] = [];
  masterDetailRecords: IInventoryMasterDetail[] = [];
  masterMaleRecords: IInventoryMasterDetail[] = [];
  masterFemaleRecords: IInventoryMasterDetail[] = [];
  masterDetailRecord: IInventoryMasterDetail = new InventoryMasterDetail();

  selectedImageFile: any;
  saveSuccess: boolean;
  isAuthenticated: boolean = false;
  showQR: boolean = false;
  message = "";
  groupId: number;
  base64textString: string;
  imagePath: any;

  qr1Generated = "";
  qr2Generated = "";

  constructor(private inventoryService: InventoryService, private router: Router, 
    private detailsService: DetailsService, private route: ActivatedRoute,
    private _sanitizer: DomSanitizer, private _resizer: NgxPicaService) { }

  ngOnInit() {
    
    if(sessionStorage.getItem("token")){
        let obj = JSON.parse(sessionStorage.getItem("token"));
        if(obj && obj.Token != ""){
          this.isAuthenticated = true;
        }
      }
    else {
      this.router.navigate(['/login']);
    }
    this.message = "";

    if(sessionStorage.getItem("groupId")){
      let group = JSON.parse(sessionStorage.getItem("groupId"));
      if(group && group.GroupId != 0){
          this.groupId = group.GroupId;
      }
    }

    this.loadInventoryTypes();
    this.loadMasterDetailRecords();
    this.loadGenderList();
    
  }

  eventlog()
  {
    //console.log(this.selectedDetailType);
  }

  loadInventoryTypes(){
    this.inventoryTypes = [];
    this.inventoryService.getInventoryTypes().subscribe(
      resp => {
      this.inventoryTypes = resp;
    });
  }

  loadMasterDetailRecords(){
    this.masterDetailRecords = [];    
    this.detailsService.getMasterDetailRecords(this.groupId).subscribe(
      resp => {
      this.masterDetailRecords = resp;
      this.masterDetailRecords.forEach(detail => {
        if(detail.Sex.toLowerCase() == "male"){
          this.masterMaleRecords.push(detail);
        }
        if(detail.Sex.toLowerCase() == "female"){
          this.masterFemaleRecords.push(detail);
        }
      });

      let selectedRecord = parseInt(this.route.snapshot.paramMap.get("id"));
      let master = this.masterDetailRecords.find(record => { return record.Id == selectedRecord});
      if(master){
      	master.HatchDate = new Date(master.HatchDate);

  	    this.masterDetailRecord = master;
        if(master.Avatar && master.Avatar != ''){
          this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' 
                   + master.Avatar);
        }
  	  }
    });

  }

  loadGenderList(){
    this.genders = [
        {id:1, desc:'Male'}, 
        {id:2, desc:'Female'}, 
        {id:3, desc:'Unsexed'}
    ];
  }

  updateNewMasterDetail(){
    if(this.masterDetailRecord.SireId == 0){
      this.masterDetailRecord.Sire = "Unknown";
    }
    else {
      let Sire = this.masterDetailRecords.find(detail => { return detail.Id == this.masterDetailRecord.SireId});
      if(Sire){
        this.masterDetailRecord.Sire = Sire.AnimalName +"/"+ Sire.AnimalID;
      }
    }
    if(this.masterDetailRecord.DameId == 0){
      this.masterDetailRecord.Dame = "Unknown";
    }
    else {
      let Dame = this.masterDetailRecords.find(detail => { return detail.Id == this.masterDetailRecord.DameId});
      if(Dame){
        this.masterDetailRecord.Dame = Dame.AnimalName +"/"+ Dame.AnimalID;
      }      
    }
    let masterToSubmit = new ViewMasterDetailWithImage();
    masterToSubmit.masterDetail = this.masterDetailRecord;
    console.log(this.selectedImageFile);
    masterToSubmit.UnProcessedAvatar = this.selectedImageFile;
    this.detailsService.updateMasterDetailRecord(masterToSubmit).subscribe(
      resp => {
        this.saveSuccess = true;
        this.message = "Successfully updated Inventory Item.";
    });
  }

  onFileChanged(event) {
    this._resizer.resizeImage(event.target.files[0], 150, 150)
        .subscribe((imageResized: File) => {
                let reader: FileReader = new FileReader();
                
                reader.addEventListener('load', (event: any) => {
                    this.imagePath = event.target.result;
                }, false);

                reader.onload = this._handleReaderLoaded.bind(this);                
                reader.readAsBinaryString(imageResized);                
            }, (err) => {
                throw err.err;
            });

  }

  _handleReaderLoaded(readerEvt) {
     var binaryString = readerEvt.target.result;
      this.selectedImageFile = btoa(binaryString);
      console.log(btoa(binaryString));

      this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' 
             + this.selectedImageFile);
    }

  resetForm(){
  	this.loadMasterDetailRecords(); 
  }

  getQR1(){
    this.qr1Generated = 'http://reptilebin.com/#/add-details/'+this.masterDetailRecord.Id + '/'+ this.groupId;
  }

  getQR2()
  {
    this.qr2Generated = 'http://reptilebin.com/#/add-details/'+this.masterDetailRecord.Id + '/'+ this.groupId;
  }

  printQR(){
    const printContent = document.getElementById('generatedQRDetails');
    const printWindow = window.open('','','left=0,top=0,width=1200,height=900,toolbar=0,scrollbars=0,status=0')
    
    printWindow.document.write(printContent.innerHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();    
  }
}



// WEBPACK FOOTER //
// ./src/app/inventory-manager/edit-inventory/edit-inventory.component.ts